import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import './index.css'
import App from './App.jsx'

// 初始化 Sentry 錯誤監控
initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-green-50 p-4">
          <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
            {/* 錯誤圖示 */}
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
            </div>

            {/* 錯誤標題 */}
            <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
              糟糕！發生錯誤了
            </h2>
            
            {/* 錯誤說明 */}
            <p className="text-gray-600 mb-6 text-center leading-relaxed">
              我們已經記錄了這個錯誤，技術團隊會盡快修復。請重新載入頁面再試一次。
            </p>
            
            {/* 錯誤詳情（可展開） */}
            <details className="mb-6 text-sm">
              <summary className="cursor-pointer font-medium text-gray-700 hover:text-gray-900 mb-2">
                <span className="inline-flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  技術細節
                </span>
              </summary>
              <pre className="mt-2 p-3 bg-gray-50 rounded-lg overflow-auto text-xs text-gray-600 border border-gray-200">
                {error.toString()}
                {error.stack && `\n\n${error.stack}`}
              </pre>
            </details>
            
            {/* 操作按鈕 */}
            <div className="space-y-3">
              <button
                onClick={resetError}
                className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 active:bg-blue-800 transition-colors shadow-sm"
              >
                重新載入頁面
              </button>
              
              <button
                onClick={() => window.location.href = '/'}
                className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 active:bg-gray-300 transition-colors"
              >
                返回首頁
              </button>
            </div>
            
            {/* 支援資訊 */}
            <div className="mt-6 pt-6 border-t border-gray-200 text-center">
              <p className="text-xs text-gray-500">
                如果問題持續發生，請聯絡客服：
                <a href="mailto:nmn@wedopr.com" className="text-blue-600 hover:underline ml-1">
                  nmn@wedopr.com
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
      onError={(error, componentStack, eventId) => {
        // 錯誤發生時的額外處理（可選）
        console.error('React Error Boundary caught:', error);
        console.error('Component Stack:', componentStack);
        console.log('Sentry Event ID:', eventId);
      }}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
